import { get } from 'lodash';
import { format } from 'erisxkit/client';
import { categoryFromAssetOption } from '../utils/methods';
import { formatDateLocal, formatDateTimeLocalNumeric } from '../utils/time';
import { DEFAULT_EXCHANGE } from 'utils/parseSymbol';
import { formatUnixTsLocal } from 'utils/dateTime';

const columns = (spotProductsOptions) => [
  {
    Header: 'Date',
    id: 'date',
    accessor: (row) => formatDateLocal(get(row, 'date')),
    width: 200,
  },
  {
    Header: 'Created At',
    id: 'createdAt',
    accessor: (row) => formatDateTimeLocalNumeric(get(row, 'createdAt')),
    width: 200,
  },
  {
    Header: 'Exchange',
    id: 'exchange',
    accessor: (row) => get(row, 'exchangeMicCode', DEFAULT_EXCHANGE),
    width: 140,
  },
  {
    Header: 'Exchange Symbol',
    id: 'contractSymbol',
    accessor: (row) => get(row, 'contractSymbol', '-'),
    width: 140,
  },
  {
    Header: 'Product',
    id: 'product',
    accessor: (row) => get(row, 'productSymbol'),
    width: 140,
  },
  {
    Header: 'Contract',
    id: 'contract',
    accessor: (row) => get(row, 'clearingSymbol'),
    width: 140,
  },
  {
    Header: 'Price',
    id: 'price',
    className: 'mono',
    accessor: (row) =>
      format(get(row, 'price', '-'), {
        type: categoryFromAssetOption(
          get(row, 'quotedAssetType'),
          spotProductsOptions,
        ),
        currency: get(row, 'quotedAssetType', ''),
      }),
  },
  {
    Header: 'Settlement Price Type',
    id: 'settlementPriceType',
    accessor: (row) => get(row, 'settlementPriceType', '-'),
    width: 200,
  },
];

export default columns;
